import { useAppDispatch, useAppSelector } from "./redux";
import { updateLanguage } from "@store/globalSlice";

const useLanguage = () => {
  const { language } = useAppSelector((state) => state.globalReducer);
  const dispatch = useAppDispatch();
  return {
    language,
    updateLanguage: (lang: string) => {
      dispatch(updateLanguage(lang));
    },
  };
};
export default useLanguage;
